<div id="<%= dom_id dance %>">
  <p class="my-5">
    <strong class="block font-medium mb-1">Name:</strong>
    <%= dance.name %>
  </p>

  <% if dance.open_category %>
  <p class="my-5">
    <strong class="block font-medium mb-1">Open category:</strong>
    <%= dance.open_category.name %>
  </p>
  <% end %>

  <% if dance.closed_category %>
  <p class="my-5">
    <strong class="block font-medium mb-1">Closed category:</strong>
    <%= dance.closed_category.name %>
  </p>
  <% end %>

  <% if dance.solo_category %>
  <p class="my-5">
    <strong class="block font-medium mb-1">Solo category:</strong>
    <%= dance.solo_category.name %>
  </p>
  <% end %>
</div>
